class VelocityTheme {
  constructor() {
    this.bindMobileMenu();
    this.bindQuantitySelectors();
    this.bindQuickAdd();
  }

  bindMobileMenu() {
    const button = document.querySelector('[data-mobile-menu-button]');
    const menu = document.querySelector('[data-mobile-menu]');
    if (!button || !menu) return;

    button.addEventListener('click', () => {
      const isOpen = menu.classList.toggle('is-open');
      button.setAttribute('aria-expanded', String(isOpen));
    });
  }

  bindQuantitySelectors() {
    document.addEventListener('click', (event) => {
      const control = event.target.closest('[data-quantity-control]');
      if (!control) return;
      const wrapper = control.closest('[data-quantity-wrapper]');
      const input = wrapper?.querySelector('input[type="number"]');
      if (!input) return;
      const change = control.dataset.quantityControl === 'plus' ? 1 : -1;
      const current = Number(input.value || 1);
      const min = Number(input.getAttribute('min') || 1);
      input.value = Math.max(min, current + change);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  bindQuickAdd() {
    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('.quick-add-form');
      if (!form) return;
      event.preventDefault();

      const button = form.querySelector('button[type="submit"]');
      const originalText = button?.textContent;
      if (button) {
        button.disabled = true;
        button.textContent = 'Adding...';
      }

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        });
        if (!response.ok) throw new Error('Cart add failed');
        this.showToast('Added to your bag');
        this.refreshCartCount();
      } catch (error) {
        this.showToast('Please choose options on product page');
      } finally {
        if (button) {
          button.disabled = false;
          button.textContent = originalText;
        }
      }
    });
  }

  async refreshCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      document.querySelectorAll('[data-cart-count]').forEach((node) => {
        node.textContent = cart.item_count;
      });
    } catch (error) {}
  }

  showToast(message) {
    const toast = document.querySelector('[data-cart-toast]');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(this.toastTimer);
    this.toastTimer = window.setTimeout(() => toast.classList.remove('is-visible'), 2400);
  }
}

document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');
document.addEventListener('DOMContentLoaded', () => new VelocityTheme());
